import { render, staticRenderFns } from "./buttongroup.vue?vue&type=template&id=6bdc7abb&"
import script from "./buttongroup.vue?vue&type=script&lang=ts&"
export * from "./buttongroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdc7abb')) {
      api.createRecord('6bdc7abb', component.options)
    } else {
      api.reload('6bdc7abb', component.options)
    }
    module.hot.accept("./buttongroup.vue?vue&type=template&id=6bdc7abb&", function () {
      api.rerender('6bdc7abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/buttongroup.vue"
export default component.exports